<template>
  <div>
    <div class="form-group">
      <label for="template">Template (optional):</label>
      <b-form-select id="template" v-model="selectedTemplate" :options="templates" text-field="name">
        <template #first>
          <b-form-select-option :value="null" disabled>-- Select a template --</b-form-select-option>
        </template>
      </b-form-select>
    </div>

    <div class="form-row">
      <div class="form-group col">
        <label for="min-player-level">Min player level:</label>
        <b-form-input id="min-player-level" v-model="form.minPlayerLevel" type="number" number required></b-form-input>
      </div>
      <div class="form-group col">
        <label for="max-player-level">Max player level:</label>
        <b-form-input id="max-player-level" v-model="form.maxPlayerLevel" type="number" number required></b-form-input>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col">
        <label for="max-participants">Max participants:</label>
        <b-form-input id="max-participants" v-model="form.maxParticipants" type="number" number required></b-form-input>
      </div>
      <div class="form-group col">
        <label for="target-score">Target score:</label>
        <b-form-input id="target-score" v-model="form.targetScore" type="number" number required></b-form-input>
      </div>
      <div class="form-group col">
        <label for="score-threshold">Score threshold:</label>
        <b-form-input id="score-threshold" v-model="form.scoreThreshold" type="number" number required></b-form-input>
      </div>
    </div>

    <fieldset class="form-group">
      <legend>Score emul time step</legend>
      <duration-input v-model="form.scoreEmulTimeStep"></duration-input>
    </fieldset>

    <fieldset class="form-group">
      <legend>Score emul total time</legend>
      <duration-input v-model="form.scoreEmulTimeTotal"></duration-input>
    </fieldset>

    <fieldset class="form-group">
      <legend>Rewards</legend>
      <rewards-input v-model="form.rewards"></rewards-input>
    </fieldset>
  </div>
</template>

<script>
import DurationInput from '../DurationInput.vue';
import RewardsInput from '../RewardsInput.vue';

import { getProtoAlias } from '../../util.js';

export default {
  name: 'DerbyLeagueForm',
  components: {
    DurationInput,
    RewardsInput,
  },

  created: function() {},
  mounted: function() {},
  updated: function() {},
  destroyed: function() {},

  data: function() {
    return {
      form: {
        minPlayerLevel: 0,
        maxPlayerLevel: 0,
        maxParticipants: 0,
        targetScore: 0,
        scoreThreshold: 0,
        scoreEmulTimeStep: 0,
        scoreEmulTimeTotal: 0,
        rewards: [],
      },

      selectedTemplate: null,
    };
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },

    templates: {
      type: Array,
      default: () => [],
    },
  },
  computed: {},
  watch: {
    form: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      deep: true,
    },
    value(newValue) {
      this.form = newValue;
    },

    selectedTemplate(template) {
      this.form.minPlayerLevel = template.min_player_level;
      this.form.maxPlayerLevel = template.max_player_level;
      this.form.maxParticipants = template.max_participants;
      this.form.targetScore = template.target_score;
      this.form.scoreThreshold = template.score_threshold;
      this.form.scoreEmulTimeStep = template.score_emul_time_step;
      this.form.scoreEmulTimeTotal = template.score_emul_time_total;
      this.form.rewards = template.rewards.map(reward => {
        return {
          place: reward.place,
          protoAlias: getProtoAlias(reward.proto_id),
          amount: reward.amount,
        };
      });
    }
  },
  methods: {},
  filters: {},
}
</script>

<style scoped>
</style>